export default "/images/vendor/flag-icon-css/flags/1x1/cy.svg?8a3f7e5746121293a7c12d55dd23cf3e";